import { createContext, useContext } from 'react'
import { MWRP } from '../config/servers.js'

// Single-tenant (MWRP). This used to resolve the active tenant from the browser
// hostname; now it just exposes the one MWRP config to every component, so the
// existing useTenant() call sites keep working unchanged.

const TenantContext = createContext(MWRP)

export function TenantProvider({ children }) {
  return <TenantContext.Provider value={MWRP}>{children}</TenantContext.Provider>
}

export function useTenant() {
  return useContext(TenantContext)
}
